import React from 'react'
import { useLoaderData } from 'react-router-dom'
import PageTransition from './templateParts/PageTransition'
import ContentPanelPillGallery from './modules/ContentPanelPillGallery/ContentPanelPillGallery'
import Hero from './modules/Hero/Hero'
import SliderBrands from './modules/SliderBrands/SliderBrands'
import BookingHotel from './modules/BookingHotel/BookingHotel'
import OurLinks from './modules/OurLinks/OurLinks'
import ParallaxPicture from './modules/ParallaxPicture/ParallaxPicture'
import Ancor from './modules/Ancor/Ancor'
import HighlightsCounter from './modules/HighlightsCounter/HighlightsCounter'
import ContentGrid from './modules/ContentGrid/ContentGrid'
import NewsCarousel from './modules/NewsCarousel/NewsCarousel'
import OurCommitment from './modules/OurCommitment/OurCommitment'
import OurCultureGallery from './modules/OurCultureGallery/OurCultureGallery'
import MediaTextContentLayout from './modules/MediaTextContentLayout/MediaTextContentLayout'
import Testimonials from './modules/Testimonials/Testimonials'
import OurProperties from './modules/OurProperties/OurProperties'
import HotelBrands from './modules/HotelBrands/HotelBrands'
import OurVenues from './modules/OurVenues/OurVenues'
import HeroCustom from './modules/HeroCustom/HeroCustom'
import Timeline from './modules/Timeline/Timeline'
import MediaContentLayoutVersionTwo from './modules/MediaContentLayoutVersionTwo/MediaContentLayoutVersionTwo'
import ContactUs from './modules/ContactUs/ContactUs'
import InstagramGallery from './modules/InstagramGallery/InstagramGallery'
import SimpleBanerCta from './modules/SimpleBanerCta/SimpleBanerCta'
import CarouselOtherNews from './modules/CarouselOtherNews/CarouselOtherNews'
// import for new component DO NOT DELETE

export default function Page() {
  const data = useLoaderData()

  const renderComponents = () => {
    if (!data) return null
    const componentList = data.map((x, i) => {
      switch (x.acf_fc_layout) {
        case 'ContentPanelPillGallery':
          return <ContentPanelPillGallery key={i} data={x} />
        case 'Hero':
          return <Hero key={i} data={x} />
        case 'SliderBrands':
          return <SliderBrands key={i} data={x} />
        case 'BookingHotel':
          return <BookingHotel key={i} data={x} />
        case 'OurLinks':
          return <OurLinks key={i} data={x} />
        case 'ParallaxPicture':
          return <ParallaxPicture key={i} data={x} />
        case 'Ancor':
          return <Ancor key={i} data={x} />
        case 'HighlightsCounter':
          return <HighlightsCounter key={i} data={x} />
        case 'ContentGrid':
          return <ContentGrid key={i} data={x} />
        case 'NewsCarousel':
          return <NewsCarousel key={i} data={x} />
        case 'OurCommitment':
          return <OurCommitment key={i} data={x} />
        case 'OurCultureGallery':
          return <OurCultureGallery key={i} data={x} />
        case 'MediaTextContentLayout':
          return <MediaTextContentLayout key={i} data={x} />
        case 'Testimonials':
          return <Testimonials key={i} data={x} />
        case 'OurProperties':
          return <OurProperties key={i} data={x} />
        case 'HotelBrands':
          return <HotelBrands key={i} data={x} />
        case 'OurVenues':
          return <OurVenues key={i} data={x} />
        case 'HeroCustom':
          return <HeroCustom key={i} data={x} />
        case 'Timeline':
          return <Timeline key={i} data={x} />
        case 'MediaContentLayoutVersionTwo':
          return <MediaContentLayoutVersionTwo key={i} data={x} />
        case 'ContactUs':
          return <ContactUs key={i} data={x} />
        case 'InstagramGallery':
          return <InstagramGallery key={i} data={x} />
        case 'SimpleBanerCta':
          return <SimpleBanerCta key={i} data={x} />
        case 'CarouselOtherNews':
          return <CarouselOtherNews key={i} data={x} />
        default:
          return null
      }
    })
    return componentList
  }

  return <PageTransition>{renderComponents()}</PageTransition>
}
